import React, { FC, useEffect, useState } from 'react';
import { ContentPage } from '../../../contentPage/scenes';
import { ResponsiveWrapper, Title } from './Atoms';
import { useMeasure } from 'react-use';
import { useCurrentLanguage } from '../../../../config/i18n';

export const COLUMNS_BREAKPOINT = 900;

export const PublicPagesInfo: FC = () => {
  const [ref, { width }] = useMeasure<HTMLDivElement>();
  const [twoColumns, setTwoColumns] = useState<boolean | undefined>();
  const currentLanguage = useCurrentLanguage();

  useEffect(() => {
    setTwoColumns(width > COLUMNS_BREAKPOINT);
  }, [width]);

  return currentLanguage != null ? (
    <>
      {/* TODO - NEEDS TRANSLATION <Title>{t('security.publicPagesInfo.title')}</Title> */}
      <Title>Allesomvattende boekvervangende methodes</Title>
      <ResponsiveWrapper className={twoColumns ? 'two-columns' : undefined} innerRef={ref}>
        <ContentPage id={`${currentLanguage}_public_page_info_col_1`} autoHeight omitTitle />
        <ContentPage id={`${currentLanguage}_public_page_info_col_2`} autoHeight omitTitle />
      </ResponsiveWrapper>
    </>
  ) : null;
};
